import TaggingNameFiscalCodeCard from './nameFiscalCodeCard.tagging';
import { ICheckoutData } from '../../checkoutEnergy.models';
import { useEnergyCheckout } from '../../../energy.context';
import { useFiscalCodeFlow } from '@vfit/consumer/hooks';
import {
  CONSUMER_CMS_SHOPPING_CART,
  IPersonalInfoCmsMobile,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API } from '@vfit/shared/data-access';
import { organizeRetriveFiscalCodeEnergy } from './nameFiscalCodeCard.utils';

const NameFiscalCodeCard = ({
  handleOnChangeEnableGoNext,
  handleOnClose,
  handleGoNextSlide,
}: ICheckoutData) => {
  const { findCaller, isModalButtonSticky, product, setFindCaller, setCurrentStepKey } =
    useEnergyCheckout();
  // state variables
  const fiscalCode = '';
  const isValidUser = false;
  const {
    isLoading: isLoadingFiscalCodeFlow,
    isError: isErrorFiscalCodeFlow,
    errorCode,
    errorMessage,
    getFindCallerResponse,
  } = useFiscalCodeFlow({
    fiscalCode,
    owningDataIsValid: isValidUser,
    isFlowEnabled: true,
  });
  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA_ENERGY
  ) as IPersonalInfoCmsMobile;
  const nameFiscalCodeConfigCms = organizeRetriveFiscalCodeEnergy(dataFromCms, product);
  return (
    <div>
      <TaggingNameFiscalCodeCard />
      {/*Use NameFiscalCode component instead. See namefiscalcodecard.tsx in ibuymobile*/}
      {/*use only onchange for check the data and the isValidUser*/}
      <p>Name fiscal code card</p>
      <button onClick={() => handleGoNextSlide?.()}>Go next</button>
    </div>
  );
};

export default NameFiscalCodeCard;
